 import debug from 'debug';

const log = debug('Breakpoints');

class Breakpoints {
	
	constructor(el) {
		this.el = el;
	}

	/**
	 * @param {string} breakpoint 
	 * 
	 * @return {boolean}
	 */
	MediaBreakpointDown(breakpoint) {
		const mediaQueryList = window.matchMedia(`(max-width: ${ this.BreakpointOptions(breakpoint)})`);

		return mediaQueryList.matches;
	}

	/**
	 * @param {string} breakpoint 
	 * 
	 * @return {boolean}
	 */
	MediaBreakpointUp(breakpoint) {
		let mediaQueryList = window.matchMedia(`(min-width: ${ this.BreakpointOptions(breakpoint)})`);

		return mediaQueryList.matches;
	}

	// Breakpoints are also set in this scss file: "\Minetilbud\Shared\Design101\1-Settings\_Settings.scss"
	BreakpointOptions(breakpoint) {
		let option;
		switch(breakpoint.toLowerCase()) {
			case 'xxs':
				option = '0px';
				break;
			case 'xs':
				option = '374px';
				break;
			case 'xsx':
				option = '413px';
				break;
			case 'xsm':
				option = '424px';
				break;
			case 'xsmx':
				option = '476px';
				break;
			case 'sm':
				option = '576px';
				break;
			case 'md':
				option = '768px';
				break;
			case 'lg':
				option = '992px';
				break;
			case 'xl':
				option = '1200px';
				break;
			case 'xxl':
				option = '1280px';
				break;
		}
		return option;
	}
}

export default Breakpoints;
